export default {
    data() {
        return {
            techTypeAxeInterventionConst: [
                {label: this.$t('tech_type_axe.a'), value: 'A'},
                {label: this.$t('tech_type_axe.rn'), value: 'RN'},
                {label: this.$t('tech_type_axe.rd'), value: 'RD'},
                {label: this.$t('tech_type_axe.autre'), value: 'AUTRE'},
            ],
        }
    },
    methods: {
        displayForTechTypeAxeInterventionConst(value) {
            let result = this.techTypeAxeInterventionConst.find(el => el.value === value);
            return result ? result.label : '';
        },
        getTechTypeAxeInterventionConst() {
            return this.techTypeAxeInterventionConst;
        }
    }
}